<script setup>
import { computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps({
  active: Boolean,
  title: String,
  href: String,
});

const classes = computed(() =>
  props.active
    ? "block text-sm py-1 pl-4 mt-2 rounded font-bold text-white bg-oteo-300"
    : "block text-sm py-1 pl-4 my-2 "
);
</script>
<template>
  <div class="rounded" :class="{ 'bg-oteo-100': active }">
    <Link :href="href" :class="classes">
      {{ title }}
    </Link>
    <div v-if="active" class="py-2 bg-oteo-100 rounded rounded-t-none">
      <slot />
    </div>
  </div>
</template>
